var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"icon",class:{ locked: _vm.locked },style:(_vm.posStyle),attrs:{"title":_vm.title,"aria-hidden":"true"}},[_c('img',{style:({ width: _vm.size + 'px', height: _vm.size + 'px' }),attrs:{"src":_vm.src,"alt":""}})])}
var staticRenderFns = []

export { render, staticRenderFns }